import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#E5DDD5] p-8 text-center">
          <div>
            <p className="text-[#111B21] text-lg mb-2">Ocorreu um erro inesperado</p>
            <p className="text-[#667781] text-sm">{this.state.error?.message ?? 'Erro desconhecido'}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
